import script from "./azureLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./azureLogin.vue?vue&type=script&setup=true&lang=ts"

import "./azureLogin.vue?vue&type=style&index=0&id=79f77100&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f77100"]])

export default __exports__